/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasLuogoDataDoc
 * @restrict E
 * @description Widget che permette la scelta di un luogo e una data per la generazione dei documenti
 * @param {function} formAccepted - Funzione eseguita quando si preme il pulsante "Completa" e i dati inseriti sono validi. I parametri disponibili sono "luogo" e "data"
 */
(function() {
	"use strict";
	angular.module("cbl.insuranceloanpmi.mf.directives").directive("creasLuogoDataDoc", [ 'CONSTANTS', function(CONSTANTS) {
		
		var controller = function($scope, labelSrvc) {
			$scope.msg = labelSrvc.getLabel;
			
			this.luogodoc = null;
			this.datadoc = null;
			
			this.dateOptions = {
                formatDay: 'dd',
                formatMonth: 'MM',
                formatYear: 'yyyy',
                startingDay: 1
            };
			
			this.status = {
					opened: false
			};

			var self = this;

			/**
			 * @ngdoc method
			 * @name openCalendar
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasLuogoDataDoc
			 * @description Apre il selettore calendario per la scelta della data
			 */
            this.openCalendar = function ($event) {
                this.status.opened = true;
            };
            
            /**
			 * @ngdoc method
			 * @name confirmData
			 * @methodOf cbl.insuranceloanpmi.mf.directive:creasLuogoDataDoc
			 * @description Esegue la verifica sui dati inseriti e lancia l'evento in output, passando tali valori se validi
			 */
            this.confirmData = function () {
            	
            	if (!self.luogodoc) {
            		return;
            	}
            	
            	if (self.luogodoc.trim() === '') {
            		return;
            	}
            	
            	if (!self.datadoc) {
            		return;
            	}
            	
            	if (typeof $scope.formAccepted === 'function') {
            		$scope.formAccepted({ luogo: self.luogodoc, data: self.datadoc });
            	}
            };
		};

		controller.$inject = ['$scope', 'LabelSrvc'];
		
		return {
			restrict : "E",
			scope : {
				formAccepted: '&'
			},
			templateUrl : CONSTANTS.BASE_ROOT + "widgets/creasLuogoDataDoc/creasLuogoDataDoc.html",
			controller: controller,
			controllerAs: "creasLuogoDataDocCtrl",
		};
	}]);
}());


//////////////////
// WEBPACK FOOTER
// ./app/widgets/creasLuogoDataDoc/creasLuogoDataDocDrct.js
// module id = 9
// module chunks = 0 1